import { render, staticRenderFns } from "./KrsModal.vue?vue&type=template&id=62e95fb8&"
import script from "./KrsModal.vue?vue&type=script&lang=js&"
export * from "./KrsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports